import { DatePicker } from 'components/atoms'
import { t } from 'i18next'
import moment from 'moment'
import { EExamStatus } from 'pages/patientBooking/enums'
import { useState } from 'react'
import styled from 'styled-components'
import { getBeginDate, getEndDate } from 'utils'

const StyledDatePicker = styled(DatePicker)`
  margin-bottom: 12px;
`

interface IProps {
  bookingIdSelected?: number
  examStatusDefault?: Array<EExamStatus>
  rootPath?: string
  defaultValue?: { from?: Date; to?: Date }
  value?: { from?: Date; to?: Date }
  onChange?: (rangeDate: { from?: Date; to?: Date }) => void
}

const DatePickerRange = (props: IProps) => {
  const { onChange, defaultValue, value } = props
  const [from, setFrom] = useState<any>(
    defaultValue?.from ? moment(defaultValue?.from) : undefined
  )
  const [to, setTo] = useState<any>(
    defaultValue?.to ? moment(defaultValue?.to) : undefined
  )

  const handleSetFrom = (date: any) => {
    if (new Date(date).getTime() > new Date(to).getTime()) {
      setTo(undefined)
    }
    if (date) {
      setFrom(moment(getBeginDate(date)))
      if (onChange)
        onChange({
          from: getBeginDate(date),
          to: to ? getEndDate(to) : undefined
        })
    } else {
      setFrom(date)
      if (onChange)
        onChange({ from: undefined, to: to ? getEndDate(to) : undefined })
    }
  }

  const handleSetTo = (date: any) => {
    if (date) {
      setTo(moment(getEndDate(date)))
      if (onChange)
        onChange({
          to: getEndDate(date),
          from: from ? getBeginDate(from) : undefined
        })
    } else {
      setTo(date)
      if (onChange)
        onChange({ to: undefined, from: from ? getBeginDate(from) : undefined })
    }
  }

  const fromValue = value?.from ? moment(value?.from) : from
  const toValue = value?.to ? moment(value?.to) : to

  return (
    <>
      <StyledDatePicker
        title={t('from-date')}
        placeholder={t('please-select-date')}
        value={fromValue}
        format="DD/MM/YYYY"
        onChange={handleSetFrom}
      />
      <StyledDatePicker
        title={t('to-date')}
        format="DD/MM/YYYY"
        placeholder={t('please-select-date')}
        value={toValue}
        min={fromValue ? new Date(fromValue) : undefined}
        onChange={handleSetTo}
      />
    </>
  )
}

export default DatePickerRange
